// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2xbQm","menu__section":"Menu_menu__section__2m7Ne"};